import { render, staticRenderFns } from "./TechSupport.vue?vue&type=template&id=0d18a7eb&scoped=true"
import script from "./TechSupport.vue?vue&type=script&lang=js"
export * from "./TechSupport.vue?vue&type=script&lang=js"
import style0 from "./TechSupport.vue?vue&type=style&index=0&id=0d18a7eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d18a7eb",
  null
  
)

export default component.exports